import { Atom } from 'AppReact'

import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme, displayState }) => css`
    width: 24.14px;
    height: 16.98px;
    background-color: ${displayState?.backgroundColor ? displayState.backgroundColor : theme?.colour?.primary ?? "#1DBD6B"};
    border-radius: 30px;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`;

export default Atom({ type: 'label', dataType: 'number', template })